// 搜尋框裡的「事件種類的說法」換成 class:（第七輪 R7-P0-1、B7-01：警報卡寫「設備被拆除或遮擋」，去搜「拆除」0 筆）。
// 伺服器的全文 body 只有 class 的四語系名稱（`tamper` =「破壞 遮擋」），沒有 notify 範本的字（拆除）、也沒有每個事件 key 的顯示名
// （影像訊號中斷）。在送出前把這些詞換成那一類的 class:，搜得到同一類的事件；伺服器補齊 body 之後這張表可以拿掉。
// 只換「整個詞」（不是欄位語法、不是 -排除、不是引號片語）；換了的詞在畫面上提示「「拆除」= 破壞 / 遮擋類事件」。

/** class → 會被認成這一類的說法（四語系；小寫比對）。 */
const CLASS_TERMS: Record<string, string[]> = {
  tamper: [
    '拆除', '被拆除', '遮擋', '被遮擋', '破壞', '拆除或遮擋', '設備被拆除或遮擋', '影像訊號中斷', '訊號中斷', '影像中斷', '攝影機被移動', '鏡頭被遮擋',
    '遮挡', '被遮挡', '破坏', '设备被拆除或遮挡', '视频信号中断', '影像信号中断', '信号中断', '摄像头被移动', '镜头被遮挡',
    'tamper', 'tampered', 'video_loss', 'videoloss',
    '妨害', '映像信号断', '映像信号途絶',
  ],
};

const TERM_CLASS = new Map<string, string>();
for (const [cls, words] of Object.entries(CLASS_TERMS)) for (const w of words) TERM_CLASS.set(w.toLowerCase(), cls);

/** 搜尋字串 → 換過的字串與換了哪些詞（給提示）。 */
export function expandEventTerms(q: string): { q: string; hits: { term: string; cls: string }[] } {
  const hits: { term: string; cls: string }[] = [];
  const classes = new Set<string>();
  const out: string[] = [];
  for (const tok of q.split(/\s+/).filter(Boolean)) {
    const cls = !tok.includes(':') && !tok.startsWith('-') && !tok.startsWith('"') ? TERM_CLASS.get(tok.toLowerCase()) : undefined;
    if (cls) {
      hits.push({ term: tok, cls });
      classes.add(cls);
    } else out.push(tok);
  }
  if (classes.size) out.push('class:' + [...classes].join(','));
  return { q: out.join(' '), hits };
}
